<template>
  <div class="share-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/07/share_icon.png"
           alt="">
      分享管理
    </div>
    <el-form ref="form"
             :model="form"
             class="add_share"
             :inline="true">
      <router-link to="share/addShare">
        <el-button type="warning"
                   size="small"
                   class="add_btn">添加</el-button>
      </router-link>
    </el-form>
    <div class="share_table">
      <el-table :data="shareData.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label=""
                         align="center"
                         type="index"
                         width="1">
        </el-table-column>
        <el-table-column prop="title"
                         header-align="center"
                         align="center"
                         label="标题"
                         min-width="130">
        </el-table-column>
        <el-table-column prop="content"
                         label="内容"
                         header-align="center"
                         align="center"
                         min-width="70">
        </el-table-column>
        <el-table-column label="图片"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div class="imgUrl"><img :src="scope.row.image"
                   alt=""></div>
          </template>
        </el-table-column>
        <el-table-column label="网页模板图片"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div class="imgUrl"><img :src="scope.row.image"
                   alt=""></div>
          </template>
        </el-table-column>
        <el-table-column prop="url"
                         label="URL"
                         header-align="center"
                         align="center"
                         min-width="70">
        </el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{shareData.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="shareData.pageSize"
                     layout="prev, pager, next"
                     :total="shareData.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { shareList, deleteShare } from 'apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'Container',
  data () {
    return {
      form: {
        name: ''
      },
      shareData: []
    }
  },
  // computed: mapState({
  //   showAddShare: state => state.share.show
  // }),
  mounted () {
    this.getShareData()
  },
  methods: {
    getShareData () { // 获取信息
      shareList().then(res => {
        if (res.data.code === 200) {
          this.shareData = res.data.data
        }
      })
    },
    // handleAddClick () { // 添加share
    //   // this.$store.commit('share/showAddShare', true)
    //   // const shareInfo = {
    //   //   image: 'http://img.zcool.cn/community/01528a58e4c8e6a801219c77b0154e.png@900w_1l_2o_100sh.jpg'
    //   // }
    //   // this.$store.commit('share/updateShare', shareInfo)
    // },
    handleUpdateClick (id) { // 修改
      this.$router.push({ path: 'share/addShare', query: { item: id } })
      // updateShare({ id: id }).then(res => {
      //   if (res.data.code === 200) {
      //     this.$store.commit('share/showAddShare', true)
      //     const shareInfo = res.data.data
      //     this.$store.commit('share/updateShare', shareInfo)
      //   }
      // })
    },
    handleDeleteClick (id) { // 删除
      deleteShare({
        id: id
      }).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.shareData.result.length; i++) { // 从当前列别表中删除该数据
            if (this.shareData.result[i].id === id) {
              this.shareData.result.splice(i, 1)
              this.shareData.total -= 1
            }
          }
        }
      })
    },
    handleCurrentChange (val) { // 分页
      let pageNum = val
      shareList({ pageNum }).then(res => {
        if (res.data.code === 200) {
          this.shareData = res.data.data
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.share-container
  padding 20px
  height 100%
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    background #fff
    .title_img
      margin 0 8px 0 14px
  .add_share
    width 100%
    height 50px
    position relative
    background #fff
    .add_btn
      float right
      margin-right 20px
      margin-top 10px
      addBtn()
  .share_table
    height calc(100% - 170px)
  .el-table
    background #f7f9fb
    .cell
      size12()
      .el-button
        padding 6px 14px
        width 28px
        cursor pointer
        height 28px
        margin 0 8px
        &.update
          update()
        &.unblocked
          unblocked()
        &.delete
          delete()
    .imgUrl
      width 80px
      height 46px
      margin 0 auto
      img
        width 80px
        height 46px
  .el-table th
    background #e7f0f8
    .cell
      height 25px
      line-height 25px
      color #212832
.el-popover
  max-width 166px
  background #e6f3fe
  border 1px solid #cfd5dc
  border-radius 1px
  size12()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
  .el-table td, .el-table th
    vertical-align center
</style>
